import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { FC } from 'react'

type Props = {
  overwrittenCount: number
  onCancel: () => void
  onOk: () => void
}

export const TableRowHeadingPasteOverwriteConfirmDialog: FC<Props> = ({
  overwrittenCount,
  onCancel,
  onOk,
}) => (
  <Dialog open onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>
      {overwrittenCount}
      行の見出しが上書きされます。上書きした見出しは元に戻せません。貼り付けてよろしいですか？
    </DialogTitle>
    <DialogActions>
      <Button variant="outlined" onClick={onCancel}>
        キャンセル
      </Button>
      <Button variant="contained" onClick={onOk}>
        上書きして貼り付ける
      </Button>
    </DialogActions>
  </Dialog>
)
